import * as React from 'react';
import {useEffect, useState} from 'react';
import {useGetEmployees} from '@/hooks/useGetEmployees';
import type {Employee} from '@/types/Employee';

type EmployeeProviderContextInterface = {
    employees : Employee[] | null;
    setEmployees : (employeex : Employee[] | null) => void;
};

type EmployeeProviderContextProviderProps = {children : React.ReactNode};

// @ts-expect-error @typescript-eslint/ban-ts-comment
// eslint-disable-next-line max-len
const EmployeeProviderContext = React.createContext<EmployeeProviderContextInterface>({} satisfies EmployeeProviderContextInterface as EmployeeProviderContextInterface);

const useEmployeeProvider = () : EmployeeProviderContextInterface => {
    const context = React.useContext(EmployeeProviderContext);

    if (Object.keys(context).length === 0) {
        throw new Error('useEmployeeProvider must be used within a EmployeeProvider');
    }

    return context;
};

const EmployeeProvider = ({children} : EmployeeProviderContextProviderProps) : JSX.Element => {
    const employeeGetQuery = useGetEmployees();
    const [employees, setEmployees] = useState<Employee[] | null>(null);

    useEffect(() => {
        if (employeeGetQuery.data !== undefined && employees === null) {
            const sortedEmployees = [...employeeGetQuery.data]
                .sort((a, b) => {
                    return a.firstName.localeCompare(b.firstName) || a.lastName.localeCompare(b.lastName);
                });

            setEmployees(sortedEmployees);
        }
    }, [employeeGetQuery]);

    const value = {
        employees,
        setEmployees,
    };

    return (
        <EmployeeProviderContext.Provider value={value}>
            {children}
        </EmployeeProviderContext.Provider>
    );
};

export {EmployeeProvider, useEmployeeProvider};
